module.exports = __webpack_public_path__ + "img/body-2-lg.8cbb8d8d.png";